import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PromoCodeBaseState } from './promo-code-base.model';
import { FEATURE_NAME } from './promo-code-base.constant';

export const selectPromoCodeBaseState = createFeatureSelector<PromoCodeBaseState>(FEATURE_NAME);

export const selectPromoCodeRedemptions = createSelector(
  selectPromoCodeBaseState,
  (state) => state.redemptions
);

export const selectLastPromoCodeRedemption = createSelector(
  selectPromoCodeBaseState,
  (state) => state.lastRedemption
);

export const selectSubmittedPromoCode = createSelector(
  selectPromoCodeBaseState,
  (state) => state.submitted
);

export const selectResolvedPromoCodeFlow = createSelector(
  selectPromoCodeBaseState,
  (state) => state.resolvedFlow
);
